/**
 * Build GO4 A4 slip + GoDEX outside HTML after one account enrich.
 * Printed content stays in the existing builders; this only parallelizes work.
 */
import {
  buildOrderDeskPackingSlipHTML,
  PACKING_SLIP_DEFAULT_LOGO_URL,
} from './packingSlipHtml';
import { buildGo4OutsideLabelHTML } from './go4OutsideLabelHtml';
import { enrichOrdersWithAccountDeliveryFields } from './enrichOrdersWithAccountDeliveryFields';

export async function buildGo4PrintDocuments(orders, options = {}) {
  let list = Array.isArray(orders) ? orders : [orders];
  if (options.enrichAccounts !== false) {
    list = await enrichOrdersWithAccountDeliveryFields(list);
  }
  const logoUrl = options.logoUrl || PACKING_SLIP_DEFAULT_LOGO_URL;
  const showSignatureLines =
    options.showSignatureLines !== false &&
    options.settings?.showSignatureLines !== false;
  const [slipHtml, outsideHtml] = await Promise.all([
    buildOrderDeskPackingSlipHTML(list, {
      logoUrl,
      settings: options.settings,
      weightsData: options.weightsData || {},
      enrichAccounts: false,
    }),
    buildGo4OutsideLabelHTML(list, {
      logoUrl,
      enrichAccounts: false,
      showSignatureLines,
    }),
  ]);
  return { orders: list, slipHtml, outsideHtml };
}

export default buildGo4PrintDocuments;
